<div class="move-panel">
  <h2 class="move-text">Move {{ getCodesSelected() }} {{ codeName }}(s) to</h2>
  <mat-form-field class="move-panel-mat-form-field">
    <mat-select
      class="category-select"
      *ngIf="customerGroups"
      [(ngModel)]="selectedGroup"
    >
      <mat-option *ngFor="let group of customerGroups" [value]="group.id">{{
        group.displayAlias
      }}</mat-option>
    </mat-select>
    <mat-placeholder class="select-placeholder"
      >Select category</mat-placeholder
    >
  </mat-form-field>
  <button
    mat-raised-button
    (click)="moveBtnClicked()"
    class="move-btn green-btn"
    [disabled]="!selectedGroup || !codesSelected"
  >
    MOVE
  </button>
</div>
